import React, { Suspense, useCallback } from 'react'
import {
  Route,
  Switch,
  Redirect,
  NavLink,
  withRouter,
  useRouteMatch,
} from 'react-router-dom'
import { Navbar, Toast, Loader } from 'sputnik-ui'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { Typography, IconButton, Tooltip } from '@material-ui/core'
import { KeyboardArrowRight, FileCopy, Update } from '@material-ui/icons'

import { AppTemplate } from 'components'
import { clearStatus, showInfoMessage } from 'store/ui/actions'
import { receiveNewOrder, updateOrdersList } from 'store/orders/actions'
import { getMsg, getError } from 'store/resources/selectors'

import useOrdersListStatus from 'hooks/useOrdersListStatus'
import { useTranslation } from 'react-i18next'
import requireAuth from '../utils/requireAuth'
import ProfileModal from './organisms/ProfileModal'
import { PrivateRouteUser } from './atoms/PrivateRoutes'

const EmergencyHomePage = React.lazy(() => import('./pages/EmergencyHomePage'))
const EmergencyAdminPage = React.lazy(() =>
  import('./pages/EmergencyAdminPage')
)

const EmergencyApp = ({ currentAddress, msg, info, error, dispatch }) => {
  const { t } = useTranslation([
    'common',
    'orders',
    'geo',
    'info',
    'devices',
    'time',
  ])

  // websockets
  const onMsgReceived = useCallback(
    ({ event, order }) => {
      switch (event) {
        case 'created':
          return dispatch(receiveNewOrder(order))
        case 'updated':
          return dispatch(updateOrdersList(order))
        default:
          return new Error('Order Message Error')
      }
    },
    [dispatch]
  )
  useOrdersListStatus(onMsgReceived)

  const copySome = (e) => {
    const el = document.createElement('textarea')
    el.value = e
    document.body && document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body && document.body.removeChild(el)
    dispatch(showInfoMessage(t('info:copy.phone')))
  }

  console.log('emergency update works')
  return (
    <AppTemplate header={<Navbar logo app="cck" shadow user copy={copySome} />}>
      <Suspense
        fallback={
          <Loader
            fullPage
            style={{
              justifyContent: 'center',
              display: 'flex',
            }}
          />
        }
      >
        <Switch>
          <Route component={EmergencyHomePage} exact path="/emergency_app" />
          <Route
            component={EmergencyAdminPage}
            exact
            path="/emergency_app/admin"
          />

          <Route
            component={EmergencyAdminPage}
            exact
            path="/emergency_app/admin"
          />
          <Redirect to="/emergency_app" />
        </Switch>
      </Suspense>

      <Toast
        open={!!info}
        handleClose={() => dispatch(clearStatus())}
        variant="info"
      >
        {info}
      </Toast>
      <Toast
        title={t('common:toast.success')}
        open={!!msg}
        handleClose={() => dispatch(clearStatus())}
        variant="success"
      >
        {msg}
      </Toast>
      <Toast
        title={t('common:toast.error')}
        open={!!error}
        handleClose={() => dispatch(clearStatus())}
        variant="error"
        style={{
          whiteSpace: 'pre-line',
        }}
      >
        {error}
      </Toast>
    </AppTemplate>
  )
}

const mapStateToProps = ({
  resources,
  devices,
  keys,
  installations,
  installationsNew,
  ui,
  orders,
  partners,
  codes,
}) => ({
  parents: resources.current.parents,
  currentAddress: resources.current.fullAddress,
  error:
    devices.error ||
    keys.error ||
    installations.error ||
    orders.error ||
    partners.error ||
    installationsNew.error ||
    ui.error ||
    codes.error ||
    getError(resources),

  msg:
    devices.msg ||
    codes.msg ||
    keys.msg ||
    installations.msg ||
    installationsNew.msg ||
    orders.msg ||
    partners.msg ||
    getMsg(resources),
  info: ui.info,
  newOrder: ui.newOrder,
})

export default connect(mapStateToProps)(withRouter(requireAuth(EmergencyApp)))
